<template>
  <div class="col-md-12">
    <div class="card card-container">
      <img
        id="profile-img"
        src="/img/logo_mag.svg"
        class="profile-img-card"
      />
      <Form @submit="ResetPassword" :validation-schema="schema">
        <div class="text-field__icon"  >
          <label for="username" class="bold">Адрес электронной почты</label>
          <Field name="username" type="text" class="text-field__input" style="width: 85%;"/>
          <ErrorMessage name="username" class="error-feedback small" />
        </div>
        <div class="text-field__icon" v-if="!success" >
          <button class="btn btn-primary btn-block" style="margin-top:32px;" :disabled="loading">
            <span
              v-show="loading"
              class="spinner-border spinner-border-sm"
            ></span>
            <span>Восстановить пароль</span>
          </button>
        </div>
        <div class="form-group" :style="{ 'margin-top': '20px' }">
          <div v-if="message.includes('успешно')"
               class="alert alert-success"
               :style="{ color: 'green' }"
               role="alert">
            {{ message }}
            <div style="width: 100%; display: flex; justify-content: center;">
              <button
                  class="btn btn-primary"
                  style="margin-top: 32px; max-width: 300px;"
                  @click="goToHome"
                  :disabled="loading">
                <span v-show="loading" class="spinner-border spinner-border-sm"></span>
                <span>Перейти на главную</span>
              </button>
            </div>
          </div>
          <div v-else
               class="alert alert-danger"
               :style="{ color: 'red' }"
               role="alert">
            {{ message }}
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

  <script>
  import { Form, Field, ErrorMessage } from "vee-validate";
  import * as yup from "yup";
  import axios from 'axios'

  export default {

    name: "Login",
    components: {
      Form,
      Field,
      ErrorMessage,
    },
    data() {
      const schema = yup.object().shape({
        username: yup.string().required("Необходимо ввести логин!"),
      });

      return {
        loading: false,
        message: "",
        success: false,
        schema,
      };
    },
    methods: {
      ResetPassword(user) {
        this.loading = true;

        const baseURL = this.$store.state.domain+'/api/polygon/reset_password';
        const params = {
          "Email": user.username
        }

        axios
          .post(baseURL, { params })
          .then(response => {

            this.loading = false;

            this.message = response.data.answer

            if (this.message === "Пароль успешно изменён и отправлен на Вашу почту!") {
              this.success = true
            }
          })
          .catch(e => {
            console.log(e);
          });
      },
      goToHome() {
        this.$router.push('/')
      }
    },
  };
  </script>

  <style scoped>
  label {
    display: block;
    margin-top: 10px;
  }

  .card-container.card {
    max-width: 350px !important;
    padding: 40px 40px;
  }

  .card {
    background-color: #f7f7f7;
    padding: 20px 25px 30px;
    margin: 0 auto 25px;
    margin-top: 50px;
    -moz-border-radius: 2px;
    -webkit-border-radius: 2px;
    border-radius: 2px;
    -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  }

  .profile-img-card {

    margin: 0 auto 10px;
    display: block;

  }
  </style>